export const CARD_HEIGHT = 88;
export const CARD_WIDTH = 63;

// Default card back image (will be added to /public/assets/)
export const DEFAULT_CARD_BACK = '/assets/card-back.png';
